module.exports = __webpack_public_path__ + "static/artist-development-results-ab7e3e35507506547a452439a9a93692.png";